export const heroImage = {
  url: "/assets/osc-banner.png",
  description: "OSC Collision Repairs shop sign under spotlights",
};

export const marqueeItems = [
  "Collision Repair",
  "Vehicle Restoration",
  "Custom Paint",
  "Okanagan Street Customs",
  "Quality Without Compromise",
];

export const services = [
  {
    num: "01",
    title: "Collision Repair",
    image: "https://images.unsplash.com/photo-1526634140919-468dc3ae3870?auto=format&fit=crop&w=1200&q=80",
    blurb:
      "From fender benders to full structural rebuilds — we bring damaged vehicles back to factory spec and beyond.",
    points: ["Frame & structural straightening", "Panel replacement & alignment", "Insurance claim support", "Post-repair safety inspection"],
  },
  {
    num: "02",
    title: "Vehicle Restoration",
    image: "https://images.unsplash.com/photo-1458942521101-2f2fb506cee3?auto=format&fit=crop&w=1200&q=80",
    blurb:
      "Full nut-and-bolt restorations that honour the original machine — metalwork, mechanicals, and finish, all under one roof.",
    points: ["Full & partial restorations", "Rust repair & metal fabrication", "Period-correct detailing", "Mechanical refresh"],
  },
  {
    num: "03",
    title: "Custom Paint & Refinish",
    image: "https://images.pexels.com/photos/30250199/pexels-photo-30250199.jpeg?auto=compress&cs=tinysrgb&w=1200",
    blurb:
      "Precision colour matching and show-quality finishes sprayed in-house — from factory touch-ups to full custom coats.",
    points: ["Computerized colour matching", "Full resprays", "Custom colours & stripes", "Ceramic-grade clear coats"],
  },
];

export const extraServices = [
  "Dent & scratch repair",
  "Bumper repair & refinishing",
  "Glass & trim replacement",
  "Headlight restoration",
  "Detailing & final QC",
  "Free repair estimates",
];

export const gallery = [
  {
    title: "Mercedes E-Class — Front End Finish",
    tag: "Collision",
    image: "/assets/gallery/photo1.jpg",
  },
  {
    title: "Copper Classic — Full Custom",
    tag: "Restoration",
    image: "/assets/gallery/photo2.jpg",
  },
  {
    title: "Corvette Drop-Top — At The Shop",
    tag: "Custom",
    image: "/assets/gallery/photo3.jpg",
  },
];

export const googleReviews = {
  score: "4.7",
  count: 24,
  url: "https://www.google.com/search?q=okanagan+street+customs+ltd+kelowna#lrd=0x537d8cce12700001:0x61fdc1b533c1035a,1,,,",
};

export const featuredReviews = [
  {
    quote:
      "I recently had someone back into me as I was parked near my work and no note left. I'm very happy that they could get me in so fast with a fantastic job for a great price — I chose not to go through insurance for it, it actually cost less than the deductible.",
    name: "Nathien Brian",
    stars: 5,
    source: "Google Review",
  },
  {
    quote:
      "I recently got my bumper repaired here and they did a great job. The price was very reasonable compared to other quotes I got, and the quality of the work honestly surprised me. The fit and paint look really good and the turnaround time was quick too. Staff were easy to deal with and explained everything clearly. Definitely recommend if you need affordable body work done.",
    name: "Levi Frederiksen",
    stars: 5,
    source: "Google Review",
  },
];

export const team = [
  {
    num: "01",
    title: "The Whole Crew",
    image: "/assets/team/floor.jpg",
    blurb: "Certified journeymen mid-restoration — every project gets the whole shop's eyes on it.",
  },
  {
    num: "02",
    title: "On The Floor",
    image: "/assets/team/crew.jpg",
    blurb: "Real people, real craft — the hands your vehicle is in, every single day.",
  },
];

export const brandLogos = [
  { name: "Honda", logo: "/assets/brands/honda.svg" },
  { name: "Toyota", logo: "/assets/brands/toyota.svg" },
  { name: "Mazda", logo: "/assets/brands/mazda.svg" },
  { name: "Mercedes-Benz", logo: "/assets/brands/mercedes.svg" },
  { name: "Dodge" },
  { name: "ICBC" },
];

export const contactInfo = {
  address: "2323 Hunter Rd, Unit #7, Kelowna, BC",
  phone: "(250) 864-5030",
  email: "okanaganstreetcustoms@gmail.com",
  hours: "Mon – Fri, 8:00 AM – 5:30 PM",
};
